
import { Table, Stack, FormControl, Avatar, RadioGroup, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, IconButton, Autocomplete, TextField, InputAdornment, useTheme, FormControlLabel, Button, Toolbar, Radio, Card, CardContent } from "@mui/material";

import { styled } from '@mui/material/styles';

import React, { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";

import { AddCircleOutline, CardGiftcard, DragIndicator } from '@mui/icons-material';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { addDays } from "date-fns";


import CallAlertBar from "../../../Layout/Alertbar";
import PurchaseActionMenu from "../order/PurchaseOrderSubMenu";
import AddNewPurchaseReceive from "../receives/AddPurchaseReceives";

import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import PurchaseOrderReport from "../order/PurchaseOrderPDF";

import jsPDF from 'jspdf';
import PurchaseBillActionMenu from "../bill/BillSubMenu";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import CustomAutocomplete from "../../../pages/commancomponents/customAutoComplete";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import PaymentTermForm from "../../../components/PaymentTermsAdd";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


const taxes = [
  { id: 1, label: 'GST', value: 18 },
  { id: 2, label: 'VAT', value: 15 },
];


const AddNewPurchaseBills = ({ handlecallback, editPurchaseOrderNumber }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = React.useState(0);


  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };


  const callback = () => {
    handlecallback();
  }

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });

  const [orderFromDate, setOrderFromDate] = useState(dayjs());
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(dayjs(addDays + 15));

  // multiple selection options

  const [paymentTerms, setPaymentTerms] = useState([]);
  const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
  const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
  const [paymentTermsID, setPaymentTermsID] = useState(0);
  const [isPaymentTermsLoaded, setIsPaymentTermsLoaded] = useState(false);

  // List of Parameter
  const [selectedPartyID, setSelectedPartyID] = useState(0);
  const [selectedParty, setSelectedParty] = useState(null);
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [poDate, setPODate] = useState(dayjs());
  const [deliveryDate, setDeliveryDate] = useState('');
  const [paymentID, setPayymentID] = useState(0);
  const [shipmentReferenceNumber, setShipmentReferenceNumber] = useState('');
  const [customerNotes, setCustomerNotes] = useState('');
  const [subTotal, setSubTotal] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [discountID, setDiscountID] = useState(0);
  const [discountValue, setDiscountValue] = useState(0);
  const [adjustmentValue, setAdjustmentValue] = useState(0);
  const [tcsID, setTCSID] = useState(0);
  const [tcsValue, setTCSValue] = useState(0);
  const [totalAmountValue, setTotalAmountValue] = useState(0);
  const [termsConditions, setTermsConditions] = useState('');

  const creditTerms = [
    { id: 1, Description: 'Net 30 Days' },
    { id: 2, Description: 'Net 60 Days' },
    { id: 3, Description: '2% 10 Net 30' },
    { id: 4, Description: 'COD (Cash on Delivery)' },
    { id: 5, Description: 'Advance Payment' },
  ];


  const [isLoadEditPO, setLoadEditPO] = useState(false);
  const [rows, setRows] = useState([{ id: 1, product: '', productId: 0, account: null, accountId: 0, quantity: 1, rate: 0.0, tax: 0.0, amount: 0.0 }]);
  // const [products, setProducts] = useState([]); // Add a state to hold product options
  // const [purchaseAccounts, setPurchaseAccounts] = useState([]); // Add a state to hold account options

  const [poNumber, setPONumber] = useState([]);
  const [isPONumberLoaded, setIsPONumberLoaded] = useState(false);

  const [products, setProduct] = useState([]);
  const [isProductsLoaded, setIsProductLoaded] = useState(false);

  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [isPurchaseAccounts, setIsPurchaseAccounts] = useState(false);
  const [discount, setDiscount] = useState(null);
  const [adjustment, setAdjustment] = useState(0);
  const [tcs, setTcs] = useState(null);
  const [selectedTCS, setSelectedTcs] = useState(null);

  useEffect(() => {
    if (!isProductsLoaded) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.PRODUCT_ITEM_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) { setProduct(data); }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isProductsLoaded]);



 

  useEffect(() => {
    if (!isPurchaseAccounts) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_ACCOUNTS, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setPurchaseAccounts(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isPurchaseAccounts]);





  useEffect(() => {
    const fetchData = async () => {
      if (!isLoadEditPO && editPurchaseOrderNumber != 0) {
        try {
          const para = {
            p_companyid: 1,
            purchase_order_id: editPurchaseOrderNumber,
          };

          const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PURCHASE_ORDER, 'POST', { 'Content-Type': 'application/json' }, para);
          const purchaseOrder = purchaseOrderResponse[0];

          const productPara = { p_companyid: 1 };
          const accountPara = { p_companyid: 1 };

          const [productsData, accountsData] = await Promise.all([
            callApi(API_ENDPOINTS.PRODUCT_ITEM_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),
            callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_ACCOUNTS, 'POST', { 'Content-Type': 'application/json' }, accountPara)
          ]);

          if (productsData && productsData.length > 0) setProduct(productsData);
          if (accountsData && accountsData.length > 0) setPurchaseAccounts(accountsData);

          if (purchaseOrder) {
            setPONumber(purchaseOrder.purchase_order_number);
            setReferenceNumber(purchaseOrder.reference);
            setShipmentReferenceNumber(purchaseOrder.shipment_reference);
            setSelectedPartyID(purchaseOrder.id_party);
            setPaymentTermsID(purchaseOrder.id_payment_terms);
            setOrderFromDate(purchaseOrder.po_date);
            setExpectedDeliveryDate(purchaseOrder.expiry_delivery_date);
            setCustomerNotes(purchaseOrder.customer_notes);
            setTermsConditions(purchaseOrder.terms_conditions);

            const productData = typeof purchaseOrder.product_list === 'string' ? JSON.parse(purchaseOrder.product_list) : purchaseOrder.product_list;

            const mappedRows = productData.map(item => ({
              ...item,
              product: productsData.find(p => p.id === item.productId) || '',
              account: accountsData.find(a => a.id === item.accountId) || '',
            }));

            setRows(Array.isArray(productData) ? mappedRows : []);

            updatePartyListAndSetSelectedParty(purchaseOrder.id_party);
            updateTCSList(purchaseOrder.id_tcs);
            updateDiscountList(purchaseOrder.id_discount);
            setAdjustment(purchaseOrder.adjustment_value);

            // Update formData with fetched values
            updateFormData(mappedRows, purchaseOrder);
          }
        } catch (error) {
          callError('error', error.message, 'Error');
        }
      }
    };

    fetchData();
  }, [isLoadEditPO, editPurchaseOrderNumber]);

  const [allPOData, setAllPOData] = useState({});

  const updateFormData = (productData, purchaseOrder) => {
    const subtotal = productData.reduce((sum, item) => sum + item.amount, 0);
    const totalQuantity = productData.reduce((sum, item) => sum + item.quantity, 0);

    const formData = {
      partyName: 'Gowtham Group of Companies', // Update as per your requirement
      purchaseOrderNumber: purchaseOrder.purchase_order_number,
      referenceNumber: purchaseOrder.reference,
      date: dayjs(purchaseOrder.po_date).format('DD-MMM-YYYY'),
      expectedDeliveryDate: dayjs(purchaseOrder.expiry_delivery_date).format('DD-MMM-YYYY'),
      paymentTerms: 'Net (15 days)', // Fetch from data if available
      shipmentPreference: purchaseOrder.shipment_reference,
      products: productData.map(item => ({
        code: item.product.code,
        description: item.product.description,
        account: item.account.description,
        quantity: item.quantity,
        rate: item.rate,
        amount: item.amount,
      })),
      customerNotes: purchaseOrder.customer_notes,
      subtotal: subtotal,
      totalQuantity: totalQuantity,
      discountPercentage: '5%', // Fetch from data if available
      discountValue: purchaseOrder.discount_value,
      adjustment: purchaseOrder.adjustment_value,
      tcsPercentage: '1%', // Fetch from data if available
      tcsValue: purchaseOrder.tcs_value,
      total: subtotal - (subtotal * 0.05) + adjustment + (subtotal * 0.01), // Example calculation
    };
    setAllPOData(formData);
    // Generate PDF (example)
    // generatePDF(formData);
  };




  const updatePartyListAndSetSelectedParty = (selectedPartyID) => {
    const para = {
      p_companyid: 1,
    }

    callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          setPartyList(data);
          const selected = data.find(party => party.id === selectedPartyID);
          if (selected) {
            setSelectedParty(selected);
          }
        }
      })
      .catch(error => {
        // handle error
        callError('error', error.message, 'Error');
      });
  };

  //TCS
  const updateTCSList = (selectedTCSID) => {
    const para = {
      p_companyid: 1,
    }
    callApi(API_ENDPOINTS.TCS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {

        if (data && data.length > 0) {
          settcsOptions(data);
          const selected = data.find(party => party.id === selectedTCSID);
          if (selected) {
            setTcs(selected);
          }
        }
      })
      .catch(error => { callError('error', error.message, 'Error'); });

  };

  // Discount
  const updateDiscountList = (selectedDiscountID) => {
    const para = {
      p_companyid: 1,
    }
    callApi(API_ENDPOINTS.DISCOUNT_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {

        if (data && data.length > 0) {
          setDiscounts(data);
          const selected = data.find(party => party.id === selectedDiscountID);
          if (selected) {
            setDiscount(selected);
          }
        }
      })
      .catch(error => { callError('error', error.message, 'Error'); });

  };







  useEffect(() => {
    if (!isPaymentTermsLoaded) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PAYMENT_TERMS, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) { setPaymentTerms(data); }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isPaymentTermsLoaded]);




  const [discounts, setDiscounts] = useState([]);
  const [isDiscounts, setIsDiscounts] = useState(false);
  useEffect(() => {
    if (!isDiscounts) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.DISCOUNT_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDiscounts(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isDiscounts]);


  const [tcsOptions, settcsOptions] = useState([]);
  const [istcsOptions, setIstcsOptions] = useState(false);
  useEffect(() => {
    if (!istcsOptions) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.TCS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            settcsOptions(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [istcsOptions]);



  const handleOpenMenu = (setter) => (event) => {
    setter(event.currentTarget);
  };

  const handleCloseMenu = (setter) => () => {
    setter(null);
  };

  const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
    setSelectedOption(option);
    setSelectedID(option ? option.id : null);
    handleCloseMenu();
  };


  const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);

  const handleAddOption = (label) => () => {
    if (label == 'Payment Term') {
      setPaymentTermDialogOpen(true);
    }
  };











  const handleAddRow = () => {
    const newRowId = rows.length + 1;
    const newRow = { id: newRowId, product: '', productId: 0, account: null, accountId: 0, quantity: 1, rate: 0.0, tax: 0.0, amount: 0.0 };
    setRows([...rows, newRow]);
  };


  const removeRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1); // Remove the row at the specified index
    setRows(updatedRows);
  };


  const handleProductChange = (index, product) => {
    const newRows = [...rows];
    newRows[index].product = product;
    newRows[index].productId = product.id || '';
    newRows[index].rate = product ? product.rate : '';
    newRows[index].amount = product ? product.rate * (newRows[index].quantity || 1) : 0;
    setRows(newRows);

  };

  const handleQuantityChange = (index, quantity) => {
    const newRows = [...rows];
    newRows[index].quantity = quantity;
    newRows[index].amount = newRows[index].product ? newRows[index].product.rate * quantity : 0;
    setRows(newRows);

  };

  const handleRateChange = (index, rate) => {
    const newRows = [...rows];
    newRows[index].rate = rate;
    newRows[index].amount = rate * (newRows[index].quantity || 1);
    setRows(newRows);

  };

  const handleTaxChange = (index, tax) => {
    const newRows = [...rows];
    newRows[index].tax = tax;
    setRows(newRows);
  };

  const handleAccountChange = (index, account) => {
    const newRows = [...rows];
    newRows[index].account = account;
    newRows[index].accountId = account.id || '';
    setRows(newRows);

  };

  const calculateSubtotal = () => {
    return rows.reduce((total, row) => total + (row.amount || 0), 0);
  };

  const calculateTotalQuantity = () => {
    return rows.reduce((total, row) => total + (parseInt(row.quantity, 10) || 0), 0);
  };


  const [dDiscount, setDDiscount] = useState(0);
  const [dTCS, setDTCS] = useState(0);
  const [dadjustment, setDAdjustment] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);

  useEffect(() => {
    const subtotal = calculateSubtotal();
    const discountValue = discount ? (discount.value / 100) * subtotal : 0;
    const tcsValue = tcs ? (tcs.value / 100) * subtotal : 0;

    setSubTotal(subtotal);

    setDDiscount(discountValue);
    setDTCS(tcsValue);
    setDAdjustment(adjustment);
    setGrandTotal(subtotal - discountValue + parseFloat(adjustment || 0) + tcsValue)
  }, [rows, discount, adjustment, tcs]);

  const calculateTotal = () => {
    let subtotal = calculateSubtotal();
    let discountValue = discount ? (discount.value / 100) * subtotal : 0;
    let tcsValue = tcs ? (tcs.value / 100) * subtotal : 0;


    return subtotal - discountValue + parseFloat(adjustment || 0) + tcsValue;
  };






  // get party list
  const [partyList, setPartyList] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (!isDataLoaded) {

      const para = {
        p_companyid: 1,
      }

      callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setPartyList(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
  }, [isDataLoaded]);


  useEffect(() => {
    if (!isPONumberLoaded) {
      if (editPurchaseOrderNumber === 0) {
        const para = {
          p_companyid: 1,
          p_modeid: 0,
        }

        callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
          .then(data => {
            if (data && data.length > 0) {
              setPONumber(data[0].po_number);
            }
          })
          .catch(error => {
            callError('error', error.message, 'Error');
          });
      }
    }
  }, [isPONumberLoaded]);


  const [selectedValue, setSelectedValue] = useState('warehouses');

  const handleDeliveryAddressChange = (event) => {
    setSelectedValue(event.target.value);
  };








  const handleSaveAndDraft = () => {

    const modifiedRows = rows.map(({ product, account, ...rest }) => rest);

    const requestBody = {
      p_companyid: 1,
      p_modeid: 0,
      p_partyid: selectedPartyID,
      p_po_number: poNumber,
      p_reference_number: referenceNumber,
      p_date: dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss'),
      p_delivery_date: dayjs(expectedDeliveryDate).format('YYYY-MM-DD hh:mm:ss'),
      p_payment_termid: paymentTermsID,
      p_customer_notes: customerNotes,
      p_shipment_reference: shipmentReferenceNumber,
      p_product_list: modifiedRows,
      //p_product_list:JSON.stringify(modifiedRows),

      p_sub_total: subTotal,
      p_discountid: discountID,
      p_discount_value: dDiscount,
      p_tcsid: tcsID,
      p_tcs: dTCS,
      p_adjustment: dadjustment,
      p_terms_conditions: termsConditions,
      p_grand_total: grandTotal,
    }

    callApi(API_ENDPOINTS.PURCHASE_ORDER_ADD_PURCHASE_ORDER, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        if (data && data.length > 0) {

          setParentRollSeverityvalue('info');
          setParentRollMessageValue('New Purchase Order Created Successfully');
          setParentRollAlertTitleValue('Info');
          setParentRollMsgOpen(true);         

        }
      })
      .catch(error => {
        callError('error', error.message, 'Error');
      });
  };

  const callError = (serverityval, msg, title) => {
    // Update state with error message        
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };



  const [selectedButtonName, setSelectedButtonName] = useState('');
  const [viewPurchaseOrder, setViewPurchaseOrder] = useState(true);
  const [viewPurchaseReceive, setViewPurchaseReceive] = useState(false);

  const handlecallbackOrder = () => {
    setViewPurchaseOrder(true);
    setViewPurchaseReceive(false);
  }

  const handlecallProcess = (buttonName) => {
    if (buttonName === 'Receive') {
      setViewPurchaseOrder(false);
      setViewPurchaseReceive(true);

    }
    else if (buttonName === 'PDF') {

      let paymettermdescription = '';
      const selected = paymentTerms.find(party => party.id === paymentTermsID);
      if (selected) {
        paymettermdescription = selected.description;
      }

      const updatedPOData = {
        ...allPOData,
        discountPercentage: discount.value + "%",
        tcsPercentage: tcs.value + "%",
        paymentTerms: paymettermdescription
      };
      setAllPOData(updatedPOData);
      generatePDF();



    }
  };

  const reportRef = useRef();
  const [viewPurchaseReport, setViewPurchaseReport] = useState(false);



  const generatePDF = () => {
    setViewPurchaseOrder(false);
    setViewPurchaseReceive(false);
    setViewPurchaseReport(true);
    const doc = new jsPDF({
      format: 'a4',
      unit: 'pt'
    });

    doc.html(reportRef.current, {
      callback: function (doc) {
        doc.save('purchase_order_report.pdf');
      },
      x: 10,
      y: 10,
      width: 575, // A4 page width - margins
      windowWidth: 800, // The window width to use for rendering
    });
  };


  // const generatePDF = (data) => {
  //   const doc = new jsPDF();

  //   doc.text("Purchase Order Report", 20, 20);
  //   doc.text(`Party Name: ${data.partyName}`, 20, 30);
  //   doc.text(`Purchase Order #: ${data.purchaseOrderNumber}`, 20, 40);
  //   doc.text(`Reference #: ${data.referenceNumber}`, 20, 50);
  //   doc.text(`Date: ${data.date}`, 20, 60);
  //   doc.text(`Expected Delivery Date: ${data.expectedDeliveryDate}`, 20, 70);
  //   doc.text(`Payment Terms: ${data.paymentTerms}`, 20, 80);
  //   doc.text(`Shipment Preference: ${data.shipmentPreference}`, 20, 90);

  //   data.products.forEach((product, index) => {
  //     doc.text(`Product ${index + 1}: ${product.code}`, 20, 100 + (index * 10));
  //     doc.text(`Account: ${product.account}`, 20, 110 + (index * 10));
  //     doc.text(`Quantity: ${product.quantity}`, 20, 120 + (index * 10));
  //     doc.text(`Rate: ${product.rate}`, 20, 130 + (index * 10));
  //     doc.text(`Amount: ${product.amount}`, 20, 140 + (index * 10));
  //   });

  //   doc.text(`Customer Notes: ${data.customerNotes}`, 20, 150 + (data.products.length * 10));
  //   doc.text(`Subtotal: ${data.subtotal}`, 20, 160 + (data.products.length * 10));
  //   doc.text(`Total Quantity: ${data.totalQuantity}`, 20, 170 + (data.products.length * 10));
  //   doc.text(`Discount: ${data.discount}`, 20, 180 + (data.products.length * 10));
  //   doc.text(`Adjustment: ${data.adjustment}`, 20, 190 + (data.products.length * 10));
  //   doc.text(`TCS: ${data.tcs}`, 20, 200 + (data.products.length * 10));
  //   doc.text(`Total: ${data.total}`, 20, 210 + (data.products.length * 10));

  //   doc.save("purchase_order_report.pdf");
  // };

  const callbackPdf = () => {
    setViewPurchaseOrder(true);
    setViewPurchaseReceive(false);
    setViewPurchaseReport(false);
  }








  return (<>

    {viewPurchaseOrder && (
      <Box padding={0}>
        <Header title={editPurchaseOrderNumber == 0 ? 'New Bill' : 'Edit Bill'} subtitle="" callback={callback} />
        <Divider />
        {editPurchaseOrderNumber > 0 && (
          <>
            <PurchaseBillActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
          </>
        )}
        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
        <Box
          sx={{            
            padding: "5px",
            borderRadius: "10px",
            maxHeight: {
              xs: '72vh', // Extra small devices (phones)
              sm: '72vh', // Small devices (tablets)
              md: '74vh', // Medium devices (small laptops)
              lg: '74vh', // Large devices (desktops)
              xl: '82vh', // Extra large devices (large desktops)
            },
            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: colors.primary[400],
              borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: colors.blueAccent[600],
              borderRadius: '10px',
              '&:hover': {
                background: colors.blueAccent[800],
              },
            },
            '&::-webkit-scrollbar-corner': {
              background: colors.primary[700],
            }
          }}>

          <Grid container  >



            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}  >

              <Grid container padding="15px 0px 20px 20px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Party Name
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={4}>


                  <Autocomplete
                    size="small"
                    fullWidth
                    options={partyList}

                    value={selectedParty}
                    onChange={(event, newValue) => {
                      setSelectedParty(newValue);
                      setSelectedPartyID(newValue?.id || null);
                    }}
                    getOptionLabel={(option) => option.companyname || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                    renderOption={(props, option) => (
                      <Box sx={{ backgroundColor: colors.primary[400] }} component="li" {...props} display="flex" alignItems="center">
                        <Avatar src={option.avatarUrl} alt={option.companyname} sx={{ marginRight: 2 }} />
                        <Box display="flex" flexDirection="column">
                          <Typography variant="subtitle2" component="div">
                            {option.companyname}
                          </Typography>
                          <Box display="flex" justifyContent="space-between" width="100%">
                            <Box display="flex" alignItems="center">
                              <EmailIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                              <Typography variant="body2" color="textSecondary">
                                {option.email}
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem sx={{ marginX: 1 }} />
                            <Box display="flex" alignItems="center">
                              <BusinessIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                              <Typography variant="body2" color="textSecondary">
                                {option.name}
                              </Typography>
                            </Box>
                          </Box>

                        </Box>

                      </Box>

                    )}
                  />
                </Grid>


              </Grid>

            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
              <Grid container padding="40px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left" >
                    Bill Number #
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField   fullWidth size="small" label="" required variant="outlined" />
                </Grid>

              </Grid>
            </Grid>


            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                  <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Purchase Order #
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField value={poNumber} fullWidth size="small" label="" required variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CustomTooltip
                            title={
                              <span>
                                <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                              </span>}
                          >
                            <SettingsIcon style={{ fontSize: "20px" }} />
                          </CustomTooltip>

                        </InputAdornment>
                      ),
                    }} />
                </Grid>


              </Grid>
            </Grid>

            {/* <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Reference #
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField value={referenceNumber} onChange={(e) => setReferenceNumber(e.target.value)} fullWidth size="small" label="" required variant="outlined" />
                </Grid>


              </Grid>
            </Grid> */}

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                   Bill Date
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        value={dayjs(orderFromDate)}
                        onChange={(date) => setOrderFromDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Due Date
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        value={dayjs(expectedDeliveryDate)}
                        onChange={(date) => setExpectedDeliveryDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth

                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Payment Terms
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3} lg={1.8} xl={1.5}>
                  <CustomAutocomplete
                    label="Payment Term"
                    options={paymentTerms}
                    selectedOption={selectedPaymentTerm}
                    setSelectedOption={setSelectedPaymentTerm}
                    setAnchorEl={setPaymentTermAnchorEl}
                    anchorEl={paymentTermAnchorEl}
                    handleOpenMenu={handleOpenMenu(setPaymentTermAnchorEl)}
                    handleCloseMenu={handleCloseMenu(setPaymentTermAnchorEl)}
                    filterText={paymentTermFilterText}
                    setFilterText={setPaymentTermFilterText}
                    handleSelectOption={handleSelectOption(setSelectedPaymentTerm, setPaymentTermsID)}
                    handleAddOption={handleAddOption('Payment Term')}
                    selectedID={paymentTermsID}
                    setSelectedID={setPaymentTermsID}
                    isRequired={true}
                  />

                </Grid>


              </Grid>
            </Grid>

            

            <Grid item xs={12} xl={12} mt={5} >
              <Divider />
            </Grid>


            <Grid item xs={12} lg={11} xl={10} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                 <CustomTableContainer colors={colors}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Product</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Account</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Quantity</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Rate</TableCell>
                            {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Tax</TableCell> */}
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <Autocomplete
                                  size="small"
                                  fullWidth

                                  placeholder="Type or click to select an product"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiSelect-select': {
                                      padding: '0px',
                                    },
                                  }}

                                  options={products}
                                  value={row.product}
                                  getOptionLabel={(option) => `${option.code} - ${option.description}`}
                                  onChange={(event, newValue) => handleProductChange(index, newValue)}
                                  renderInput={(params) => (
                                    <TextField

                                      size="small"
                                      placeholder="Type or click to select an product"
                                      fullWidth
                                      {...params}
                                      // label="Product"
                                      variant="outlined"
                                    />
                                  )}
                                />

                              </TableCell>
                              <TableCell style={{ size: "small", width: "250px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <Autocomplete
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiSelect-select': {
                                      padding: '8px',
                                    },
                                  }}
                                  options={purchaseAccounts}
                                  value={row.account}
                                  getOptionLabel={(option) => option.description}
                                  onChange={(event, newValue) => handleAccountChange(index, newValue)}
                                  renderInput={(params) => (
                                    <TextField
                                      fullWidth
                                      {...params}
                                      placeholder="Select an account"
                                      // label="Account"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity}
                                  onChange={(e) => handleQuantityChange(index, e.target.value)}
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  // label="Rate"
                                  variant="outlined"
                                  type="number"
                                  value={row.rate}
                                  onChange={(e) => handleRateChange(index, e.target.value)}
                                />
                              </TableCell>
                              {/* <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
                              <Select
                                fullWidth
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiSelect-select': {
                                    padding: '8px',
                                  },
                                }}
                                value={row.tax}
                                onChange={(e) => handleTaxChange(index, e.target.value)}
                                displayEmpty
                                variant="outlined"
                              >
                                <MenuItem value="" disabled>
                                  Select Tax
                                </MenuItem>
                                {taxes.map((tax) => (
                                  <MenuItem key={tax.value} value={tax.value}>
                                    {tax.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </TableCell> */}
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  value={row.amount}
                                  variant="outlined"
                                  disabled
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '0px solid transparent', fontSize: '12px', padding: 0 }}>
                                <IconButton onClick={() => removeRow(index)} color="secondary">
                                  <HighlightOffOutlinedIcon sx={{ color: '#ef5350', fontSize: "16px" }} />
                                </IconButton >
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <Box mt={2}>
                        <Button
                          size="small"
                          variant="contained"
                          color="secondary"
                          sx={{ textTransform: "none" }}
                          startIcon={<AddCircleOutline />}
                          onClick={handleAddRow}
                        >
                          Add New Row
                        </Button>
                      </Box>
                    </TableContainer>
                    </CustomTableContainer>
                </Grid>
              </Grid>
            </Grid>


            <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
              <Box padding={1} sx={{
                display: 'flex',
                alignItems: 'center',
                borderColor: 'divider',
                borderRadius: 2,
                color: 'text.secondary', '& svg': { m: 1, },
              }} >
                <Grid container spacing={0}>
                  <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                    
                    <Grid item xs={12} lg={12} xl={10}>
                      
                    </Grid>
                  </Grid>

                  <Grid item xs={10} md={6} lg={5.5} xl={3.6}  >
                    <Box p={2} sx={{ backgroundColor: colors.primary[400], borderRadius: "10px" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography marginLeft="12px" variant="h5" fontWeight="bold">Subtotal</Typography>
                          <Typography marginLeft="12px" fontSize="12px" >Total Quantity : {calculateTotalQuantity()}</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {calculateSubtotal().toFixed(2)}</Typography>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-start">
                          <Autocomplete
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSelect-select': {
                                padding: '0px',
                              },
                            }}
                            options={discounts}
                            value={discount}
                            getOptionLabel={(option) => option.description}
                            onChange={(event, newValue) => { setDiscount(newValue); setDiscountID(newValue.id) }}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                                label="Discount"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {dDiscount.toFixed(2)}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <TextField
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSelect-select': {
                                padding: '0px',
                              },
                            }}
                            label="Adjustment"
                            variant="outlined"
                            type="number"
                            value={adjustment}
                            onChange={(e) => setAdjustment(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {dadjustment}</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Autocomplete
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSelect-select': {
                                padding: '0px',
                              },
                            }}
                            options={tcsOptions}
                            value={tcs}
                            getOptionLabel={(option) => option.description}
                            onChange={(event, newValue) => { setTcs(newValue); setTCSID(newValue.id) }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="TCS"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {dTCS.toFixed(2)}</Typography>
                        </Grid>

                        <Grid item xs={12} container justifyContent="flex-end">
                          <Typography variant="h5">Total : {calculateTotal().toFixed(2)}</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>


                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} xl={12} mt={3} padding={2} >

              <Box padding={2} sx={{
                display: 'flex',
                backgroundColor: colors.primary[400],
                alignItems: 'center',                
                borderColor: 'divider',
                borderRadius: 2,                
                color: 'text.secondary',
                '& svg': {
                  m: 1,
                },
              }} >
                <Grid container spacing={2}>
                  <Grid item xs={6} xl={6} marginRight={2}>
                    <Typography variant="h5" fontWeight="bold">Terms & Conditions</Typography>
                    <TextField value={termsConditions} onChange={(e) => setTermsConditions(e.target.value)} type="text" multiline fullWidth placeholder="Enter the Terms And Condition for the purchase order. " />
                  </Grid>
                  <Divider orientation="vertical" marginLeft="10px" variant="middle" flexItem />
                  <Grid item xl={4}>
                    <Typography variant="body1" fontWeight="bold">Attache File(s) to Purchase Order</Typography>
                    <div>
                      <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        sx={{ textTransform: "none" }}                       
                        onClick={handleAddRow}
                      >
                        Add File
                      </Button>
                    </div>

                  </Grid>

                </Grid>
              </Box>
            </Grid>

          </Grid>

        </Box>



        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

              <Toolbar>
                <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} startIcon={<DraftsOutlinedIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Draft</Button>
                <Button size="small" variant="contained" color="secondary" startIcon={<SendOutlinedIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Save And Send</Button>
                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
              </Toolbar>
            </Box>
          </Grid>
        </Grid>

        <PaymentTermForm open={isPaymentTermDialogOpen} onClose={() => setPaymentTermDialogOpen(false)} terms={paymentTerms} setTerms={setPaymentTerms} />

      </Box>
    )}
    {viewPurchaseReceive && (
      <AddNewPurchaseReceive handlecallback={handlecallbackOrder} editPurchaseOrderNumber={editPurchaseOrderNumber} editPurchaseReceiveNumber={0} editPurchaseReceiveID={0} />
    )}

    {viewPurchaseReport && (
      <Box padding={0}>
        <Header title={'Purchase Order'} subtitle="" callback={callbackPdf} />
        <Divider />
        {editPurchaseOrderNumber > 0 && (
          <>
            <PurchaseActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
          </>
        )}
        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
        <Box sx={{
          // backgroundColor: colors.primary[700],
          padding: "5px",
          borderRadius: "10px",
          maxHeight: {
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          },
          overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.primary[400],
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.blueAccent[600],
            borderRadius: '10px',
            '&:hover': {
              background: colors.blueAccent[800],
            },
          },
          '&::-webkit-scrollbar-corner': {
            background: colors.primary[700],
          }
        }}>

          <Card style={{ backgroundColor: colors.primary[400], borderRadius: "10px" }}>
            <CardContent>              
              <PurchaseOrderReport ref={reportRef} data={allPOData} />
            </CardContent>
          </Card>



        </Box>

      </Box>
    )}
  </>)
}
export default AddNewPurchaseBills;